/* istanbul ignore file */
import checkErrors from './CheckErrors';

export default checkErrors;
